var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    baseProfile: "full",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.000000,-1.000000) translate(0,-32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 30.212346 22.077351 L 1.749034 22.077351 C 1.337066 22.077351 1.000000 21.726064 1.000000 21.296709 L 1.000000 1.780642 C 1.000000 1.351289 1.337066 1.000000 1.749034 1.000000 L 30.212346 1.000000 C 30.624316 1.000000 30.961383 1.351289 30.961383 1.780642 L 30.961383 21.296709 C 30.961383 21.726064 30.624316 22.077351 30.212346 22.077351 Z M 28.414665 20.516067 L 15.980691 7.557398 L 3.546717 20.516067 L 28.414665 20.516067 Z M 2.498069 19.423167 L 10.063318 11.538676 L 2.498069 3.654186 L 2.498069 19.423167 Z M 3.584169 2.561285 L 11.111967 10.406743 L 15.456367 5.879016 C 15.755980 5.566759 16.205402 5.566759 16.505016 5.879016 L 20.849416 10.406743 L 28.377211 2.561285 L 3.584169 2.561285 Z M 29.463313 3.654186 L 21.898066 11.538676 L 29.463313 19.423167 L 29.463313 3.654185 Z",
    transform: "scale(1.000000,1.000000) translate(0.019308,3.295761)",
    opacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.0b76d4ac49b5ed4617dfac4482bfb4b2.svg";
export { ForwardRef as ReactComponent };